import { ReactElement } from 'react';
import { components, GroupBase, MultiValueRemoveProps } from 'react-select';
import { ReactComponent as CloseIcon } from 'assets/close_icon.svg';
import { Obj } from 'types/common';
import { DEFAULT_DELETE_ICON_COLOR } from './constants';

export function MultiValueRemove<T extends Obj>(
  props: MultiValueRemoveProps<T, boolean, GroupBase<T>>
): ReactElement | null {
  if (props.data.isFixed) {
    return null;
  }

  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon key={props.data.id} height={9} width={9} stroke={DEFAULT_DELETE_ICON_COLOR} />
    </components.MultiValueRemove>
  );
}
